<template>
    <div class="widget-wrapper" v-show="isVisible"
        :class="{ 'collapsed': isCollapsed, 'initial-state': isInInitialState, 'expanded': !isCollapsed && !isInInitialState, 'closedisi': closeIsiPan }">
        <div class="widget" id="widget">
            <div class="scrollable"  @scroll="handleScroll" v-if="!isCollapsed">
                <div class="scrollable_content">
                </div>
            </div>
            <div class="collapse-head container" :data-label='dataLabel' data-category='Global ISI' @click="collapse"
                @click.stop>
                <div class="d-flex justify-content-end" :data-label='dataLabel' data-category='Global ISI'>
                    <div class="d-flex justify-content-between align-items-center head-content">
                        <span class="pt-0 pb-0 m-0" :data-label='dataLabel' data-category='Global ISI'>{{ title
                            }}</span>
                        <i v-show="isCollapsed" :data-label="openLabel" data-category='Global ISI'
                            class="fas fa-plus"></i>
                        <i v-show="!isCollapsed" :data-label="closeLabel" data-category='Global ISI'
                            class="fas fa-minus"></i>
                    </div>

                </div>

            </div>
            <div class="blue-line"></div>
            <div class="widget-content" id="widget-content">
                <irsh-indication :hideTitle="false"></irsh-indication>
            </div>
        </div>

    </div>
</template>

<script>
import DataList from '../models/dataList'
import { mapState } from "vuex"
const HEIGHT_SCROLL_BLOCK = 0;
const openISILabel = 'Open - ISI'
const closeISILabel = 'Close - ISI'

export default {
    props: ['text'],
    computed: {
        ...mapState(['indicationPos'])
    },
    data() {
        return {
            isVisible: true,
            isCollapsed: true,
            isInInitialState: true,
            list: DataList.differentDeliveryPage().widgetList,
            card: DataList.differentDeliveryPage().card,
            dataLabel: openISILabel,
            openLabel: openISILabel,
            closeLabel: closeISILabel,
            closeIsiPan: true,
            title: 'Expand'
        }
    },
    mounted() {
        this.isVisible = true;
        this.isCollapsed = true;
        this.closeIsiPan = true;
        this.isInInitialState = (window.pageYOffset === 0);

        setTimeout(() => {
            if (this.allowHideWidget()) {
                this.isVisible = false
            } else {
                this.isVisible = true
            }

        }, 0);
        let isClosed = (localStorage.getItem('journayisiclosed') === 'true');
        if (isClosed) {
            this.closeIsiPan = true
            this.isCollapsed = true
        }
        this.$root.$on('is-widget', () => {
            this.isCollapsed = true
            this.isInInitialState = (window.pageYOffset === 0);
        })
        this.$root.$on('show-widget', (data) => {
            if (data) {
                this.isCollapsed = false
                this.isInInitialState = false
                this.closeIsiPan = false
                document.body.style.overflowY = 'hidden';
                localStorage.setItem('journayisiclosed', 'false');
            }
        })
        window.addEventListener('scroll', (ev) => {
            if (window.pageYOffset > 0) {
                this.isInInitialState = false;
            } else {
                this.isInInitialState = true;
            }
            if (this.allowHideWidget()) {
                this.isVisible = false;
            } else {
                this.isVisible = true;
            }
        })
        this.$root.$on("toggle-widget", () => {
            if(this.isVisible){
                this.collapse();
            } else {
                document.getElementById("indication").scrollIntoView({ behavior: "smooth" });

            }
        });
    },
    methods: {
        height() {
            if (window.innerHeight < 600) {
                return 150
            } else {
                return 500
            }
        },
        collapse() {
            this.isCollapsed = !this.isCollapsed
            this.isInInitialState = false
            if (!this.isCollapsed) {
                document.body.style.overflowY = 'hidden';
                this.closeIsiPan = false;
                localStorage.setItem('journayisiclosed', 'false');
            } else {
                document.body.style.overflowY = 'visible';
                this.closeIsiPan = true;
                localStorage.setItem('journayisiclosed', 'true');
            }
        },
        allowHideWidget() {
            const indicationEl = document.querySelector('#indication');
            if (!indicationEl) return false;

            // Get vanish offset from CSS variable (set by IsiTuner, default 250px for redesigned options, 0px for baseline)
            const style = getComputedStyle(document.documentElement);
            const vanishOffset = parseInt(style.getPropertyValue('--isi-tuner-vanish-offset')) || 0;

            // The static footer ISI must be scrolled into the viewport by at least vanishOffset pixels
            // before the floating tray hides, preventing any visibility gap over the CTA section.
            const rect = indicationEl.getBoundingClientRect();
            return (rect.top <= (window.innerHeight - vanishOffset));
        },
        closeisi() {
            this.isVisible = false;
        },
        handleScroll(event) {
            this.collapse();
        }
    },
    watch: {
        isCollapsed: function (newValue) {
            this.title = newValue ? 'Expand' : 'Collapse';
            this.dataLabel = !newValue ? this.closeISILabel : this.openISILabel;

            if (newValue) {
                const widgetContent = document.querySelector('.widget-content');
                widgetContent.scrollTop = 0;
            }

            this.$nextTick(() => {
                const widget = document.getElementById('widget');
                if (widget) {
                    widget.classList.remove('widget-collapse', 'widget-expand');
                    widget.classList.add(newValue ? 'widget-collapse' : 'widget-expand');
                }

                setTimeout(() => {
                    if (widget.classList.contains('widget-expand')) {
                        widget.classList.add('active');
                    }
                }, 10);
            });
        }
    },
    beforeDestroy() {
        this.$root.$off("toggle-widget");
    },

}
</script>
